import { API_FIRST_TOUCH } from './EsConstants';
import { esPost } from './EsFetch';

// First touch (T3): the landing's UTM and the ad platforms' click IDs, kept from the first
// visit that carried any, so a sign-up days later still says where the browser came from.
// Nothing is sent to an ad platform from here; esback tells them at sign-up and payment
// (EsConversions), and this only posts what the URL said, just before a registration.
//
// localStorage, not a cookie: it never travels on a request by itself. Every read and write
// is guarded, because storage can be absent or refuse (a private window, blocked site data),
// and then there is simply no first touch.
export const FIRST_TOUCH_STORAGE = 'esFirstTouch';

const KEYS = [ 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'fbclid', 'rdt_cid', 'ttclid' ];

// What a query string carries of the keys, or null when it carries none.
export const esFirstTouchOf = ( pSearch, pNow ) => {
    const aParams = new URLSearchParams( pSearch || '' );
    const aTouch = {};
    KEYS.forEach( ( pKey ) => {
        const aValue = aParams.get( pKey );
        if ( aValue ) aTouch[ pKey ] = aValue;
    } );
    if ( Object.keys( aTouch ).length === 0 ) return null;
    aTouch.at = pNow;
    return aTouch;
};

export const esFirstTouchRead = () => {
    try {
        const aText = window.localStorage.getItem( FIRST_TOUCH_STORAGE );
        return aText ? JSON.parse( aText ) : null;
    } catch {
        return null;
    }
};

// Called once at load: keeps this landing only when none is kept yet.
export const esFirstTouchCapture = ( pSearch = window.location.search, pNow = Date.now() ) => {
    const aTouch = esFirstTouchOf( pSearch, pNow );
    if ( !aTouch || esFirstTouchRead() ) return;
    try {
        window.localStorage.setItem( FIRST_TOUCH_STORAGE, JSON.stringify( aTouch ) );
    } catch {
        // storage refused: no first touch
    }
};

// Posted before a registration by any road. A failure never stops the registration.
export const esFirstTouchSend = async () => {
    const aTouch = esFirstTouchRead();
    if ( !aTouch ) return;
    try {
        await esPost( API_FIRST_TOUCH, aTouch );
    } catch {
        // the sign-up goes on without it
    }
};
